import React from 'react'
import styled, { css } from 'styled-components'

// h1, h2, h3, h4, h5, h6 {
//   font-family: @header-font, sans-serif;
//   font-weight: normal;
// }
// h1 {
//   font-size: 4rem;
// }
// h2 {
//   font-size: 3rem;
// }
// h3 {
//   font-size: 2rem;
// }
// h4 {
//   font-size: 1.5rem;
// }
// h5 {
//   font-size: 1rem;
// }
// h6 {
//   font-size: .8rem;
// }
export const H1 = styled.h1`
	/* Adapt the colours based on primary prop */
	font-size: 4rem;
	font-family: 'Patrick Hand SC', sans-serif;
	font-weight: normal;
  margin-top: 0.5em;
`;

export const H3 = styled.h3`
	/* Adapt the colours based on primary prop */
  font-size: 2rem;
	font-family: 'Patrick Hand SC', sans-serif;
	font-weight: normal;
  margin-top: 0.5em;
`;



// WEBPACK FOOTER //
// ./src/components/Headers.js